import { useFormContext } from "react-hook-form";
import { z } from "zod";
import { FormField } from "@/components/ui";

export const stateSchema = z.object({
  State_Code: z
    .string()
    .min(2, "State code must be 2 characters")
    .max(2, "State code must be exactly 2 characters")
    .regex(/^[A-Z]+$/, "Only uppercase letters allowed"),

  Name: z.string().min(3, "State name must be at least 3 characters"),
});

export type StateFormData = z.infer<typeof stateSchema>;

const AddStateForm = () => {
  const {
    control,
    formState: { errors },
    clearErrors,
  } = useFormContext<StateFormData>();

  return (
    <div className="flex flex-col gap-4">
      <FormField
        control={control}
        name="Name"
        label="State Name"
        placeholder="Enter State Name"
        type="text"
        error={errors.Name?.message}
        onClear={() => clearErrors("Name")}
        required
      />

      <FormField
        control={control}
        name="State_Code"
        label="State Code"
        placeholder="Enter State Code (e.g., MH, DL)"
        type="text"
        error={errors.State_Code?.message}
        onClear={() => clearErrors("State_Code")}
        required
      />
    </div>
  );
};

AddStateForm.displayName = "AddStateForm";

export default AddStateForm;
